module.exports = __webpack_public_path__ + "img/delta-logo.7c5d3446.svg";